/**
 * Open the in-app Basecamp todo or todolist integration tab.
 * When recordType is 'todolist', opens the list viewer with proper URL routing.
 */
export function openBasecampTodoInFlowNotes(
  todoId: string,
  projectId: string,
  recordType: 'todo' | 'todolist' = 'todo',
  openInNewTab = false
): void {
  if (recordType === 'todolist') {
    window.dispatchEvent(
      new CustomEvent("integration-view-change", {
        detail: {
          tabId: `basecamp-todo-list-${todoId}`,
          title: "Loading...",
          type: "integration-basecamp-todo-list",
          openInNewTab,
          integrationData: {
            integrationId: "basecamp",
            projectId: projectId.toString(),
            listId: todoId.toString(),
          },
        },
      }),
    )
  } else {
    window.dispatchEvent(
      new CustomEvent("integration-view-change", {
        detail: {
          tabId: `basecamp-todo-${todoId}`,
          title: "Loading...",
          type: "integration-basecamp-todo",
          openInNewTab,
          integrationData: {
            integrationId: "basecamp",
            projectId: projectId.toString(),
            todoId: todoId.toString(),
          },
        },
      }),
    )
  }
}
